export const selectIsGBUser = (state) => state.user?.user?.guessedHomeCountry === 'GB';
